import { BookingDTO } from '@/clients/booking'
import { getBookingTimeline, getMainCarriageTransportMode } from '@/features/bookings'

import { OverviewItem, OverviewItemSchema } from '../domain/overviewItem.ts'

export const bookingToOverviewItem = (booking: BookingDTO): OverviewItem => {
  const transportMode = getMainCarriageTransportMode(booking.waypoints)

  const result = OverviewItemSchema.safeParse({
    id: booking.id,
    type: 'booking',
    transportMode,
    transportType: booking.transportType,
    containerQuantity: booking.cargo.length,
    state: booking.state,
    bookedDate: booking.bookedAt,
    createdDate: booking.bookedAt,
    pickupDate: booking.bookedAt, // fallback to bookedAt, since there is no pickupDate in booking
    deliveryDate: booking.deliveryDueAt,
    customerReference: booking.customerReference,
    shipper: booking.shipper?.companyName || '',
    cargo: booking.cargo,
    containerPlans: [],
    timeline: getBookingTimeline({
      waypoints: booking.waypoints,
      cargoReadyAt: booking.cargoReadyAt,
      departureAt: booking.departureAt,
      arrivalAt: booking.arrivalAt,
      deliveryDueAt: booking.deliveryDueAt,
      originPortName: booking.originPortName,
      destinationPortName: booking.destinationPortName,
    }),
  })
  if (!result.success) {
    // eslint-disable-next-line no-console
    console.error('Zod Validation Error:', result.error.format())
    throw new Error('Invalid data structure')
  }

  return result.data
}
